import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { BooleanInput, ReferenceArrayInput, SelectArrayInput, TextInput } from 'react-admin';
import { FormDataConsumer } from 'react-admin';
import { required } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import AccessRoles from './AccessRoles';
import CanViewNetwork from '../Helpers/CanViewNetwork';
import CanViewPublisher from '../Helpers/CanViewPublisher';
import PermissionRoles from './PermissionRoles';
import PopoverHelp from '../../../Common/Popovers/Help';

const styles = createStyles({
  dropdown: {
    minWidth: 230
  },
  inline: {
    display: 'inline-block'
  },
  name: {
    width: 600
  }
});

const ValidateRequired = required();

type Props = {
  classes: any,
  record: any
};

const SettingsTab = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <Field name="name" source="name" component={TextInput} label="Team Name *" validate={ValidateRequired} className={props.classes.name} /><br /><br />

    Publisher Owner (Visibility)
    <PopoverHelp content="The team can only view reporting data from publishers they subscribe to.  That way a team from company A cannot view revenue data from company B" className={props.classes.inline} /><br />
    <Field name="all_publishers" source="all_publishers" component={BooleanInput} label="All Publishers" style={{ width: '140px' }} />

    <FormDataConsumer>
      {({ formData, ...rest }) => CanViewPublisher(formData) &&
        <div>
          <Field name="publishers" source="publishers" component={ReferenceArrayInput} label="Publisher Owner (Visibility) *" resource="teams" reference="helpers/publisher_ids" className={props.classes.dropdown} allowEmpty record={props.record}>
            <Field name="publishers" source="publishers" label="Publishers" component={SelectArrayInput} />
          </Field><br /><br />
        </div>
      }
    </FormDataConsumer><br /><br />

    Network Owner (Visibility)
    <PopoverHelp content="The team can only view reporting data from networks they subscribe to.  That way a team from company A cannot view revenue data from company B" className={props.classes.inline} /><br />
    <Field name="all_networks" source="all_networks" component={BooleanInput} label="All Networks" style={{ width: '140px' }} />

    <FormDataConsumer>
      {({ formData, ...rest }) => CanViewNetwork(formData) &&
        <Field name="networks" source="networks" component={ReferenceArrayInput} label="Network Owner (Visibility) *" resource="teams" reference="helpers/networks" className={props.classes.dropdown} allowEmpty record={props.record}>
          <Field name="networks" source="networks" label="Networks" component={SelectArrayInput} />
        </Field>
      }
    </FormDataConsumer><br /><br />

    Access Roles
    <FieldArray name="access_roles" component={AccessRoles} label="Access" record={props.record} /><br /><br />

    Permission Roles
    <FieldArray name="permission_roles" component={PermissionRoles} label="Permission" record={props.record} /><br />
  </div>
);

export default withStyles(styles)(SettingsTab);



// WEBPACK FOOTER //
// ./src/views/Components/Teams/Partials/SettingsTab.tsx